// @mui
import { Container, Divider, Link, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
// routes
import { PATH_PAGE } from '../../routes/paths';
// components
import Copyright from '../../components/Copyright';
// hooks
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
}));

const LinkStyle = styled(Link)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.primary,
  marginRight: theme.spacing(2),
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
  '&:hover': {
    opacity: 0.8,
    textDecoration: 'none',
  },
}));

// ----------------------------------------------------------------------

export default function MainSimpleFooter() {
  const { translate } = useLocales();

  return (
    <RootStyle>
      <Divider />
      <Container>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={{ xs: 'center', md: 'space-between' }}
          alignItems={'center'}
          sx={{ py: 4, width: '100%' }}
          spacing={2}
        >
          <Copyright />
          <Stack px={1} direction={'row'} alignItems={'center'} flexWrap={'wrap'}>
            <LinkStyle variant="subtitle2" component={RouterLink} to={PATH_PAGE.termsPolicy}>
              {translate('termPolicy.title')}
            </LinkStyle>
            {/* <LinkStyle variant="subtitle2" component={RouterLink} to={PATH_PAGE.privacyPolicy}>
              {translate('policy.title')}
            </LinkStyle>
            <LinkStyle variant="subtitle2" component={RouterLink} to={PATH_PAGE.terms}>
              {translate('terms.title')}
            </LinkStyle> */}
            <LinkStyle variant="subtitle2" component={RouterLink} to={PATH_PAGE.contact}>
              {translate('contactus.contact_us')}
            </LinkStyle>
            {/* <LanguagePopover /> */}
          </Stack>
        </Stack>
      </Container>
    </RootStyle>
  );
}
